import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  targetDate: Date;
}
export const CountdownTimer = ({
  targetDate
}: CountdownTimerProps) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const calculateTimeLeft = () => {
      const difference = targetDate.getTime() - new Date().getTime();
      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor(difference / (1000 * 60 * 60) % 24),
          minutes: Math.floor(difference / 1000 / 60 % 60),
          seconds: Math.floor(difference / 1000 % 60)
        });
      }
    };
    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(timer);
  }, [targetDate]);
  const timeBoxClass = 'flex flex-col items-center justify-center bg-white border border-gray-200 rounded-xl p-3 sm:p-4 min-w-[70px] sm:min-w-[80px] shadow-sm';
  const numberClass = 'text-2xl sm:text-3xl md:text-4xl font-bold text-[#7B2BFD]';
  const labelClass = 'text-xs sm:text-sm text-gray-600 font-medium mt-1';
  return <div className="flex justify-center gap-3 sm:gap-4" data-id="element-6">
      <div className={timeBoxClass} data-id="element-7">
        <span className={numberClass} data-id="element-8">{timeLeft.days}</span>
        <span className={labelClass} data-id="element-9">DÍAS</span>
      </div>
      <div className={timeBoxClass} data-id="element-10">
        <span className={numberClass} data-id="element-11">{timeLeft.hours}</span>
        <span className={labelClass} data-id="element-12">HORAS</span>
      </div>
      <div className={timeBoxClass} data-id="element-13">
        <span className={numberClass} data-id="element-14">{timeLeft.minutes}</span>
        <span className={labelClass} data-id="element-15">MIN</span>
      </div>
      <div className={timeBoxClass} data-id="element-16">
        <span className={numberClass} data-id="element-17">{timeLeft.seconds}</span>
        <span className={labelClass} data-id="element-18">SEG</span>
      </div>
    </div>;
};